<template>



  <div class="min-h-screen bg-white text-gray-800 flex flex-col">

    <iframe
        src="https://calendly.com/kmccallum495/30min"
        style="width:0; height:0; border:0; position:absolute; visibility:hidden;"
        aria-hidden="true"
        tabindex="-1"
    ></iframe>
    <header class="bg-white shadow fixed top-0 left-0 w-full z-50">
      <NavBar/>
    </header>
    <main class="pt-28 flex-grow">
      <router-view/>
    </main>
    <FooterF/>
  </div>
</template>

<script setup>
import FooterF from '@/components/FooterF.vue';
import NavBar from "@/components/NavBar.vue";
</script>
